export default __webpack_public_path__ + "54b0fb757b3c267c78492b63d6f599e4.png";